function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { memo } from 'react';
import dayjs from 'dayjs';
import { BodyText } from '@keen.io/typography';
import { colors } from '@keen.io/colors';
import { Separator, Hours } from './AbsoluteTimeLabel.styles';
var DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';
var AbsoluteTimeLabel = memo(function (_ref) {
  var start = _ref.start,
      end = _ref.end;

  var _dayjs$format$split = dayjs(start.substring(0, 19)).format(DATE_TIME_FORMAT).split(' '),
      _dayjs$format$split2 = _slicedToArray(_dayjs$format$split, 2),
      startDate = _dayjs$format$split2[0],
      startHours = _dayjs$format$split2[1];

  var _dayjs$format$split3 = dayjs(end.substring(0, 19)).format(DATE_TIME_FORMAT).split(' '),
      _dayjs$format$split4 = _slicedToArray(_dayjs$format$split3, 2),
      endDate = _dayjs$format$split4[0],
      endHours = _dayjs$format$split4[1];

  return React.createElement(BodyText, {
    variant: "body2",
    color: colors.blue[500],
    enableTextEllipsis: true
  }, React.createElement("span", null, startDate), React.createElement(Hours, null, startHours), React.createElement(Separator, null, "-"), React.createElement("span", null, endDate), React.createElement(Hours, null, endHours));
});
AbsoluteTimeLabel.displayName = 'AbsoluteTimeLabel';
export default AbsoluteTimeLabel;